import { createContext, useContext, useState } from "react";

const ADDRESS = "444/177 Mallahi Tola, 2nd Barafkhana, Lucknow, U.P. 226003";

export const translations = {
  en: {
    nav: {
      services: "Services",
      gallery: "Gallery",
      scheme: "PM Surya Ghar",
      equipment: "Equipment",
      contact: "Contact",
      quote: "Get Free Quote",
    },
    hero: {
      vendor: "UP Neda Authorised Vendor · PM Surya Ghar Muft Bijli Yojana",
      finance: "0% Finance Ki Suvidha Uplabdh*",
      line1a: "Driven by",
      line1b: "nature,",
      line2a: "built for",
      line2b: "trust.",
      sub: "Powering tomorrow, today — solar, wind & AI energy solutions for homes, farms and businesses across Uttar Pradesh.",
      cta1: "Calculate Solar Savings",
      cta2: "Enquire on WhatsApp",
      estTitle: "Instant Solar Estimator",
      estBill: "Monthly electricity bill",
      estSize: "Recommended system",
      estSubsidy: "Govt. subsidy up to",
      estSave: "Est. monthly savings",
      estCta: "Get Exact Quote on WhatsApp",
      stat1n: "500+",
      stat1: "kW Installed",
      stat2n: "₹1,08,000",
      stat2: "Max Subsidy",
      stat3n: "0%",
      stat3: "Finance EMI",
    },
    surya: {
      eyebrow: "Government Scheme",
      title: "PM Surya Ghar Muft Bijli Yojana",
      desc: "As an authorised UP Neda vendor, Uma Enterprises handles your complete subsidy journey — from application to net-metering — while you enjoy up to ₹1,08,000 combined subsidy (₹78,000 Central Government + ₹30,000 UP State Government) and 0% finance on the balance.",
      subsidyLabel: "Combined subsidy up to",
      subsidyBreak: "₹78,000 Central Govt + ₹30,000 UP State Govt",
      steps: [
        { t: "Free Site Survey", d: "Our engineer visits, checks your roof and shadow-free area." },
        { t: "Subsidy Application", d: "We file your PM Surya Ghar application on the national portal." },
        { t: "Installation", d: "Certified installation with branded panels & inverters in 2-3 days." },
        { t: "Net Metering On", d: "Discom inspection, net-meter activation and subsidy credited to your bank." },
      ],
      cta: "Check My Eligibility",
    },
    services: {
      eyebrow: "What We Do",
      title: "Solar. Wind. Intelligence.",
      solar: {
        t: "Solar Renewable Energy",
        d: "Rooftop systems for homes, commercial buildings & industries. On-grid, off-grid and hybrid — engineered for maximum generation per square foot.",
        chips: ["On-Grid", "Off-Grid", "Hybrid"],
      },
      wind: {
        t: "Wind Energy",
        d: "Micro-wind turbines and hybrid wind-solar generators for round-the-clock clean power.",
      },
      ai: {
        t: "AI Energy Automation",
        d: "Smart energy management, generation forecasting, automatic load switching and live solar monitoring on your phone.",
        points: ["Live generation monitoring", "Automatic load switching", "Generation forecasting", "Mobile app control"],
      },
    },
    spec: {
      eyebrow: "We Master In",
      title: "Our Specializations",
      items: [
        { t: "Solar Rooftop Systems", d: "Residential, commercial & industrial rooftops — designed, installed and maintained end-to-end." },
        { t: "Solar Atta Chakki", d: "Flour mill solarization with high-torque inverters. Run your chakki on the sun, cut diesel to zero." },
        { t: "Solar Submersible & Tubewell", d: "Heavy-duty solar pumping for farms and agriculture — day-long water without electricity bills." },
      ],
    },
    gallery: {
      eyebrow: "Our Work",
      title: "Recent Installations",
      desc: "Real rooftops, farms and businesses across Uttar Pradesh now running on Uma Enterprises systems.",
      note: "Sample photos — being replaced with our real project photos",
    },
    equip: {
      eyebrow: "Equipment Sales",
      title: "Genuine Components. Authorised Brands.",
      desc: "Every component BIS-certified, sourced directly from authorised channels with full warranty support.",
      items: [
        "High-Efficiency Solar Panels",
        "Grid-Tie Inverters (GTI)",
        "Solar Mounting Structures",
        "ACDB & DCDB Boxes",
        "Chemical Earthing Systems",
        "Lightning Arresters",
        "Solar DC & AC Cables",
      ],
    },
    brands: {
      eyebrow: "Authorised Brand Partners",
    },
    partner: {
      label: "Service Partner",
      location: "Lucknow, Uttar Pradesh",
      description: "Solar installation and ongoing care for your panels, with maintenance and cleaning services in Lucknow.",
      services: ["Solar panel installation", "Annual maintenance (AMC)", "High-pressure panel cleaning"],
      cta: "Visit Vivan Energia",
      newTab: "Opens in a new tab",
    },
    visit: {
      address: ADDRESS,
      hours: "Mon – Sat · 10:00 AM – 7:00 PM",
      directions: "Get Directions",
    },
    form: {
      eyebrow: "Get Started",
      title: "Book Your Free Site Survey",
      desc: "Fill this in — we open WhatsApp with your details pre-filled. Our engineer calls you back within hours.",
      name: "Full Name",
      phone: "Phone Number",
      email: "Email Address",
      city: "City / Pincode",
      service: "Service Required",
      bill: "Monthly Electricity Bill",
      submit: "Send Enquiry on WhatsApp",
      note: "Submitting opens WhatsApp with your enquiry pre-filled. No spam, ever.",
      success: "Enquiry saved! Opening WhatsApp…",
      options: ["Rooftop Solar", "Solar Atta Chakki", "Solar Tubewell", "Wind Energy", "AI Automation", "Solar Equipment"],
      bills: ["Under ₹2,000", "₹2,000 – ₹5,000", "₹5,000 – ₹10,000", "Above ₹10,000"],
    },
    chat: {
      title: "Uma AI Assistant",
      subtitle: "Powered by Gemini · Ask about subsidy, sizing, price",
      placeholder: "Ask about solar subsidy, pricing…",
      greeting: "Namaste! I'm Uma, your solar assistant. Ask me about PM Surya Ghar subsidy, system sizing, pricing or 0% finance.",
      send: "Send",
      typing: "Uma is typing",
    },
    footer: {
      tagline: "Driven by nature, built for trust.",
      quickLinks: "Quick Links",
      contact: "Contact",
      vendor: "UP Neda Authorised Vendor · PM Surya Ghar Muft Bijli Yojana",
      address: ADDRESS,
      rights: "Uma Enterprises. All rights reserved.",
    },
  },

  hi: {
    nav: {
      services: "सेवाएं",
      gallery: "गैलरी",
      scheme: "PM सूर्य घर",
      equipment: "उपकरण",
      contact: "संपर्क",
      quote: "मुफ़्त कोटेशन पाएं",
    },
    hero: {
      vendor: "UP नोएडा अधिकृत विक्रेता · PM सूर्य घर मुफ़्त बिजली योजना",
      finance: "0% फाइनेंस की सुविधा उपलब्ध*",
      line1a: "प्रकृति से",
      line1b: "चलने वाली,",
      line2a: "भरोसे पर",
      line2b: "बनी ताकत।",
      sub: "कल को आज ही सशक्त बनाएं — उत्तर प्रदेश के घरों, खेतों और व्यापारों के लिए सोलर, पवन और AI ऊर्जा समाधान।",
      cta1: "सोलर बचत का हिसाब लगाएं",
      cta2: "WhatsApp पर पूछें",
      estTitle: "तुरंत सोलर अनुमान",
      estBill: "मासिक बिजली बिल",
      estSize: "अनुशंसित सिस्टम",
      estSubsidy: "सरकारी सब्सिडी तक",
      estSave: "अनुमानित मासिक बचत",
      estCta: "WhatsApp पर सही कोटेशन पाएं",
      stat1n: "500+",
      stat1: "kW इंस्टॉल",
      stat2n: "₹1,08,000",
      stat2: "अधिकतम सब्सिडी",
      stat3n: "0%",
      stat3: "फाइनेंस EMI",
    },
    surya: {
      eyebrow: "सरकारी योजना",
      title: "PM सूर्य घर मुफ़्त बिजली योजना",
      desc: "UP नोएडा के अधिकृत विक्रेता के रूप में, Uma Enterprises आपकी पूरी सब्सिडी प्रक्रिया संभालती है — आवेदन से नेट-मीटरिंग तक — और आपको ₹1,08,000 तक की कुल सब्सिडी मिलती है (₹78,000 केंद्र सरकार + ₹30,000 UP राज्य सरकार) साथ ही शेष राशि पर 0% फाइनेंस।",
      subsidyLabel: "कुल सब्सिडी तक",
      subsidyBreak: "₹78,000 केंद्र सरकार + ₹30,000 UP राज्य सरकार",
      steps: [
        { t: "मुफ़्त साइट सर्वे", d: "हमारे इंजीनियर आपकी छत और छाया-मुक्त जगह की जांच करते हैं।" },
        { t: "सब्सिडी आवेदन", d: "हम राष्ट्रीय पोर्टल पर आपका PM सूर्य घर आवेदन करते हैं।" },
        { t: "इंस्टॉलेशन", d: "ब्रांडेड पैनल और इन्वर्टर के साथ 2-3 दिनों में प्रमाणित इंस्टॉलेशन।" },
        { t: "नेट मीटरिंग शुरू", d: "डिस्कॉम निरीक्षण, नेट-मीटर एक्टिवेशन और सब्सिडी सीधे आपके बैंक में।" },
      ],
      cta: "मेरी पात्रता जांचें",
    },
    services: {
      eyebrow: "हम क्या करते हैं",
      title: "सोलर। पवन। बुद्धिमत्ता।",
      solar: {
        t: "सोलर रिन्यूएबल एनर्जी",
        d: "घरों, कमर्शियल बिल्डिंग और इंडस्ट्री के लिए रूफटॉप सिस्टम। ऑन-ग्रिड, ऑफ-ग्रिड और हाइब्रिड — हर वर्ग फुट से अधिकतम उत्पादन।",
        chips: ["ऑन-ग्रिड", "ऑफ-ग्रिड", "हाइब्रिड"],
      },
      wind: {
        t: "पवन ऊर्जा",
        d: "माइक्रो-विंड टरबाइन और हाइब्रिड विंड-सोलर जेनरेटर — चौबीसों घंटे स्वच्छ बिजली।",
      },
      ai: {
        t: "AI एनर्जी ऑटोमेशन",
        d: "स्मार्ट एनर्जी मैनेजमेंट, जेनरेशन फोरकास्टिंग, ऑटोमैटिक लोड स्विचिंग और आपके फोन पर लाइव सोलर मॉनिटरिंग।",
        points: ["लाइव जेनरेशन मॉनिटरिंग", "ऑटोमैटिक लोड स्विचिंग", "जेनरेशन फोरकास्टिंग", "मोबाइल ऐप कंट्रोल"],
      },
    },
    spec: {
      eyebrow: "हमारी विशेषता",
      title: "हम इनमें माहिर हैं",
      items: [
        { t: "सोलर रूफटॉप सिस्टम", d: "रेजिडेंशियल, कमर्शियल और इंडस्ट्रियल रूफटॉप — डिज़ाइन से इंस्टॉलेशन और मेंटेनेंस तक।" },
        { t: "सोलर आटा चक्की", d: "हाई-टॉर्क इन्वर्टर के साथ आटा चक्की सोलराइज़ेशन। चक्की चलाएं धूप से, डीज़ल खर्च जीरो।" },
        { t: "सोलर सबमर्सिबल और ट्यूबवेल", d: "खेतों और सिंचाई के लिए हेवी-ड्यूटी सोलर पंपिंग — बिना बिजली बिल के दिन भर पानी।" },
      ],
    },
    gallery: {
      eyebrow: "हमारा काम",
      title: "हालिया इंस्टॉलेशन",
      desc: "उत्तर प्रदेश भर की असली छतें, खेत और व्यापार अब Uma Enterprises के सिस्टम पर चल रहे हैं।",
      note: "सैंपल फोटो — जल्द ही असली प्रोजेक्ट फोटो लगाई जाएंगी",
    },
    equip: {
      eyebrow: "उपकरण बिक्री",
      title: "असली कंपोनेंट। अधिकृत ब्रांड।",
      desc: "हर कंपोनेंट BIS-प्रमाणित, अधिकृत चैनल से सीधे और पूरी वारंटी सपोर्ट के साथ।",
      items: [
        "हाई-एफिशिएंसी सोलर पैनल",
        "ग्रिड-टाई इन्वर्टर (GTI)",
        "सोलर माउंटिंग स्ट्रक्चर",
        "ACDB और DCDB बॉक्स",
        "केमिकल अर्थिंग सिस्टम",
        "लाइटनिंग अरेस्टर",
        "सोलर DC और AC केबल",
      ],
    },
    brands: {
      eyebrow: "अधिकृत ब्रांड पार्टनर",
    },
    partner: {
      label: "सर्विस पार्टनर",
      location: "लखनऊ, उत्तर प्रदेश",
      description: "लखनऊ में सोलर इंस्टॉलेशन और पैनलों की नियमित देखभाल, मेंटेनेंस और सफाई की सेवाएं।",
      services: ["सोलर पैनल इंस्टॉलेशन", "वार्षिक मेंटेनेंस (AMC)", "हाई-प्रेशर पैनल सफाई"],
      cta: "Vivan Energia की वेबसाइट देखें",
      newTab: "नए टैब में खुलेगा",
    },
    visit: {
      address: ADDRESS,
      hours: "सोम – शनि · सुबह 10:00 – शाम 7:00",
      directions: "रास्ता देखें",
    },
    form: {
      eyebrow: "शुरू करें",
      title: "मुफ़्त साइट सर्वे बुक करें",
      desc: "फॉर्म भरें — आपकी जानकारी के साथ WhatsApp खुल जाएगा। हमारे इंजीनियर कुछ ही घंटों में कॉल करेंगे।",
      name: "पूरा नाम",
      phone: "फोन नंबर",
      email: "ईमेल पता",
      city: "शहर / पिनकोड",
      service: "कौन सी सेवा चाहिए",
      bill: "मासिक बिजली बिल",
      submit: "WhatsApp पर पूछताछ भेजें",
      note: "सबमिट करते ही WhatsApp में आपकी पूछताछ पहले से भरी खुल जाएगी। कोई स्पैम नहीं।",
      success: "पूछताछ सेव हो गई! WhatsApp खुल रहा है…",
      options: ["रूफटॉप सोलर", "सोलर आटा चक्की", "सोलर ट्यूबवेल", "पवन ऊर्जा", "AI ऑटोमेशन", "सोलर उपकरण"],
      bills: ["₹2,000 से कम", "₹2,000 – ₹5,000", "₹5,000 – ₹10,000", "₹10,000 से ऊपर"],
    },
    chat: {
      title: "उमा AI सहायक",
      subtitle: "Gemini द्वारा · सब्सिडी, साइज़, कीमत पूछें",
      placeholder: "सोलर सब्सिडी, कीमत पूछें…",
      greeting: "नमस्ते! मैं उमा हूं, आपकी सोलर सहायक। PM सूर्य घर सब्सिडी, सिस्टम साइज़, कीमत या 0% फाइनेंस के बारे में पूछें।",
      send: "भेजें",
      typing: "उमा लिख रही है",
    },
    footer: {
      tagline: "प्रकृति से चलने वाली, भरोसे पर बनी।",
      quickLinks: "क्विक लिंक्स",
      contact: "संपर्क",
      vendor: "UP नोएडा अधिकृत विक्रेता · PM सूर्य घर मुफ़्त बिजली योजना",
      address: ADDRESS,
      rights: "Uma Enterprises. सर्वाधिकार सुरक्षित।",
    },
  },

  hinglish: {
    nav: {
      services: "Services",
      gallery: "Gallery",
      scheme: "PM Surya Ghar",
      equipment: "Equipment",
      contact: "Contact",
      quote: "Free Quote Lein",
    },
    hero: {
      vendor: "UP Neda Authorised Vendor · PM Surya Ghar Muft Bijli Yojana",
      finance: "0% Finance Ki Suvidha Uplabdh*",
      line1a: "Nature se",
      line1b: "chalti hai,",
      line2a: "bharose pe",
      line2b: "bani hai.",
      sub: "Kal ko aaj hi power karein — UP ke gharon, kheton aur business ke liye solar, wind aur AI energy solutions.",
      cta1: "Solar Saving Calculate Karein",
      cta2: "WhatsApp Pe Poochein",
      estTitle: "Instant Solar Estimator",
      estBill: "Monthly bijli ka bill",
      estSize: "Recommended system",
      estSubsidy: "Sarkari subsidy tak",
      estSave: "Estimated monthly bachat",
      estCta: "WhatsApp Pe Exact Quote Lein",
      stat1n: "500+",
      stat1: "kW Install",
      stat2n: "₹1,08,000",
      stat2: "Max Subsidy",
      stat3n: "0%",
      stat3: "Finance EMI",
    },
    surya: {
      eyebrow: "Sarkari Yojana",
      title: "PM Surya Ghar Muft Bijli Yojana",
      desc: "UP Neda ke authorised vendor ke roop mein, Uma Enterprises aapki poori subsidy process sambhalti hai — application se net-metering tak — aur aapko ₹1,08,000 tak ki total subsidy milti hai (₹78,000 Central Government + ₹30,000 UP State Government) aur baaki amount par 0% finance.",
      subsidyLabel: "Total subsidy tak",
      subsidyBreak: "₹78,000 Central Govt + ₹30,000 UP State Govt",
      steps: [
        { t: "Free Site Survey", d: "Hamare engineer aapki chhat aur shadow-free area check karte hain." },
        { t: "Subsidy Application", d: "Hum national portal par aapka PM Surya Ghar application file karte hain." },
        { t: "Installation", d: "Branded panels aur inverter ke saath 2-3 din mein certified installation." },
        { t: "Net Metering On", d: "Discom inspection, net-meter activation aur subsidy seedhe aapke bank mein." },
      ],
      cta: "Meri Eligibility Check Karein",
    },
    services: {
      eyebrow: "Hum Kya Karte Hain",
      title: "Solar. Wind. Intelligence.",
      solar: {
        t: "Solar Renewable Energy",
        d: "Gharon, commercial buildings aur industry ke liye rooftop systems. On-grid, off-grid aur hybrid — har square foot se maximum generation.",
        chips: ["On-Grid", "Off-Grid", "Hybrid"],
      },
      wind: {
        t: "Wind Energy",
        d: "Micro-wind turbines aur hybrid wind-solar generators — 24x7 saaf bijli ke liye.",
      },
      ai: {
        t: "AI Energy Automation",
        d: "Smart energy management, generation forecasting, automatic load switching aur aapke phone par live solar monitoring.",
        points: ["Live generation monitoring", "Automatic load switching", "Generation forecasting", "Mobile app control"],
      },
    },
    spec: {
      eyebrow: "Hamari Speciality",
      title: "Hum In Mein Master Hain",
      items: [
        { t: "Solar Rooftop Systems", d: "Residential, commercial aur industrial rooftops — design se installation aur maintenance tak, sab kuch." },
        { t: "Solar Atta Chakki", d: "High-torque inverters ke saath atta chakki solarization. Chakki chalayein dhoop se, diesel ka kharcha zero." },
        { t: "Solar Submersible & Tubewell", d: "Kheton aur sinchai ke liye heavy-duty solar pumping — bijli bill ke bina din bhar paani." },
      ],
    },
    gallery: {
      eyebrow: "Hamara Kaam",
      title: "Recent Installations",
      desc: "UP bhar ki asli chhatein, khet aur business ab Uma Enterprises systems par chal rahe hain.",
      note: "Sample photos — jald hi asli project photos lagayi jayengi",
    },
    equip: {
      eyebrow: "Equipment Sales",
      title: "Asli Components. Authorised Brands.",
      desc: "Har component BIS-certified, authorised channel se direct, poori warranty support ke saath.",
      items: [
        "High-Efficiency Solar Panels",
        "Grid-Tie Inverters (GTI)",
        "Solar Mounting Structures",
        "ACDB & DCDB Boxes",
        "Chemical Earthing Systems",
        "Lightning Arresters",
        "Solar DC & AC Cables",
      ],
    },
    brands: {
      eyebrow: "Authorised Brand Partners",
    },
    partner: {
      label: "Service Partner",
      location: "Lucknow, Uttar Pradesh",
      description: "Lucknow mein solar installation aur panels ki regular care — maintenance aur cleaning services ke saath.",
      services: ["Solar panel installation", "Saalana maintenance (AMC)", "High-pressure panel safai"],
      cta: "Vivan Energia Ki Website Dekhein",
      newTab: "Naye tab mein khulega",
    },
    visit: {
      address: ADDRESS,
      hours: "Mon – Sat · 10:00 AM – 7:00 PM",
      directions: "Rasta Dekhein",
    },
    form: {
      eyebrow: "Shuru Karein",
      title: "Free Site Survey Book Karein",
      desc: "Form bhariye — aapki details ke saath WhatsApp khul jayega. Hamare engineer kuch hi ghanton mein call karenge.",
      name: "Poora Naam",
      phone: "Phone Number",
      email: "Email Address",
      city: "City / Pincode",
      service: "Kaunsi Service Chahiye",
      bill: "Monthly Bijli Bill",
      submit: "WhatsApp Pe Enquiry Bhejein",
      note: "Submit karte hi WhatsApp mein aapki enquiry pehle se bhari khul jayegi. Koi spam nahi.",
      success: "Enquiry save ho gayi! WhatsApp khul raha hai…",
      options: ["Rooftop Solar", "Solar Atta Chakki", "Solar Tubewell", "Wind Energy", "AI Automation", "Solar Equipment"],
      bills: ["₹2,000 se kam", "₹2,000 – ₹5,000", "₹5,000 – ₹10,000", "₹10,000 se upar"],
    },
    chat: {
      title: "Uma AI Assistant",
      subtitle: "Gemini powered · Subsidy, size, price poochein",
      placeholder: "Solar subsidy, price poochein…",
      greeting: "Namaste! Main Uma hoon, aapki solar assistant. PM Surya Ghar subsidy, system size, price ya 0% finance ke baare mein poochein.",
      send: "Bhejein",
      typing: "Uma likh rahi hai",
    },
    footer: {
      tagline: "Driven by nature, built for trust.",
      quickLinks: "Quick Links",
      contact: "Contact",
      vendor: "UP Neda Authorised Vendor · PM Surya Ghar Muft Bijli Yojana",
      address: ADDRESS,
      rights: "Uma Enterprises. All rights reserved.",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
